// removed by extract-text-webpack-plugin
module.exports = {"card-panel":"CardShellRow__card-panel","cardPanel":"CardShellRow__card-panel","card":"CardShellRow__card","no-hpad-sm":"CardShellRow__no-hpad-sm","noHpadSm":"CardShellRow__no-hpad-sm","card-pad":"CardShellRow__card-pad","cardPad":"CardShellRow__card-pad"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShellRow/CardShellRow.scss
// module id = 1757
// module chunks = 8